export default "__VITE_ASSET__Zkqw172L__"